export default __webpack_public_path__ + "static/media/retailShop.79267b6d.webp";